import React, { useState } from 'react'
import Avatar from "@mui/material/Avatar";
import { useNavigate } from "react-router-dom";
import { Buffer } from "buffer";


function MeetingDetail({ previous, toReschedule, agenda, getId, currentProfile }) {
  const navigate = useNavigate();
const handleRes = () =>{
  toReschedule();
}
  return (
    <div className="col-span-6 gap-2 w-full h-auto relative container px-5 drop-shadow-lg mb-4">
            <div className={`rounded bg-white-1 shadow-clientCard h-72 grid grid-cols-12 gap-3 p-6 box-border border-t-4 border-blue-10`}>
              <div className="md:col-span-10 col-span-12">
                  <h1 className="w-full md:text-lg text-[18px] md:font-semibold font-Poppins">Meeting with recruiting manager for {agenda[0]?.full_name.split(' ')[0]}{agenda?.length > 1 ? ` & ${agenda?.length-1} more` : ''}</h1>
                  <div className="md:py-4 py-3">
                    <div className="w-full border-t border-grey-2"></div> 
                  </div>
                  <div className="grid grid-cols-12 md:mt-3 md:mb-3">
                      <div className="col-span-6">
                          <span className="text-black-4 md:text-base text-[12px] font-light font-Poppins">Date</span>
                          <h2 className="md:text-base text-[14px] md:font-semibold md:mt-3 mt-1 font-Poppins">{agenda[0]?.meetingDate}</h2>
                      </div>
                      <div className="col-span-6">
                          <span className="text-black-4 md:text-base text-[12px] font-light font-Poppins">Time</span>
                          <h2 className="md:text-base text-[14px] font-semibold md:mt-3 mt-1 font-Poppins">{agenda[0]?.meetingTime.split(' ')[2]} - {agenda[0]?.endMeetingTime}</h2>
                      </div>
                  </div>
                  <div className="md:py-4 pt-3">
                    <div className="w-full border-t border-grey-2"></div> 
                  </div>
                  <div className="grid grid-cols-12 md:mt-3 md:mb-3 mt-1">
                      <div className="md:col-span-4 col-span-6 flex cursor-pointer" onClick={() => window.open(`${agenda[0]?.meetingUrl}`,"_blank")}> 
                          <h2 className="text-blue-1 md:text-base text-[14px] font-normal mt-2 font-Poppins">Meeting Link</h2>
                          <img className="h-4 w-4 mt-3 ml-2" src="/link.svg" />
                      </div>
                      {!previous && <div className="col-span-6">
                          <h2 className="text-black-5 font-medium mt-2 md:text-base text-[14px] font-Poppins -ml-2 cursor-pointer hover:text-black-3" onClick={handleRes}>Reschedule Meeting</h2>
                      </div>}
                  </div>
                  <div className='flex md:hidden pt-3 -ml-3 pb-5'>
                  {
                    agenda?.length && agenda.map( (profiles, index) => (
                      <div style={{backgroundColor: profiles?.bgColor}} key={index} className={`flex ml-3 items-center justify-center rounded-full w-[45px] h-[45px] hover:border-blue-4 cursor-pointer mb-2 ${currentProfile == profiles ? 'border-blue-4 border-2' : ''}`} onClick={() => getId(profiles.id)}>
                        <Avatar alt="Profile" src={`${profiles.emoji_url}`} imgProps={ {'style':{'objectFit': 'contain'}}} sx={{ width: 24, height: 24 }} />
                      </div>
                  ))
                }
                  </div>
              </div>

              <div className="hidden md:block md:col-span-2 -mt-2 sticky top-0 overflow-y-scroll scrollbar h-full">
                {
                  agenda?.length && agenda.map( (profiles, index) => (
                    <div style={{backgroundColor: profiles?.bgColor}} key={index} className={`flex items-center justify-center rounded-full ml-5 w-[45px] h-[45px] hover:border-blue-4 cursor-pointer mb-2 ${currentProfile == profiles ? 'border-blue-4 border-2' : ''}`} onClick={() => getId(profiles.id)}>
                      <Avatar alt="Profile" src={`${profiles.emoji_url}`} imgProps={ {'style':{'objectFit': 'contain'}}} sx={{ width: 24, height: 24 }} />
                    </div>
                  ))
                }
              </div>
            </div>
            </div>
  )
}

export default MeetingDetail